import './App.css';
import logo from './assets/sensoneo-logo.svg'
import SettingsGenerator from "./SettingsGenerator";
import React, {useEffect, useState} from "react";
import {Button} from "react-bootstrap";


function App() {
    const [showSettingsGenerator, setShowSettingsGenerator] = useState(false)
    const [enteredPass, setEnteredPass] = useState("")
    const [showError, setShowError] = useState(false)

    useEffect(() => {
        document.title = "Settings generator"
    }, [])
    return (
        <div className="container-fluid">
            <div className="row bg-light text-dark pt-2 pb-2">
                <div className="col-4 col-md-2">
                    <img
                        src={logo}
                        style={{height: "100%", width: "100%"}}
                        alt="logo"/>
                </div>
                <h1 className="col-8 col-md-10 align-self-center">Settings generator</h1>
            </div>

            {showSettingsGenerator ?
                <SettingsGenerator></SettingsGenerator>
                :
                <div className="col-6 col-lg-3">
                    <h3>Type the password</h3>
                    <input type="password" className="form-control"
                           value={enteredPass}
                        onChange={e => {
                            setShowError(false)
                            setEnteredPass(e.target.value)
                        }}
                    />

                    <Button
                        className="mt-2"
                        style={{backgroundColor: "green", borderColor: "green"}}
                        onClick={e => {
                            if (enteredPass === "SensoneO_2002") {
                                setShowSettingsGenerator(true)
                            }
                            else {
                                setShowError(true)
                            }
                        }}>Let me in
                    </Button>
                    {showError ?
                    <p style={{color: "red"}}>Incorrect password</p> : null}

                </div>}
        </div>
    );
};

export default App;
